/**
 * pilotTip.tsx
 */
import PilotTipContainer from '@components/atoms/container/pilotTipContainer';
import Tip from '../tip/tip';

/**
 * Displays the pilot tip.
 */
export default function PilotTip() {
  return (
    <PilotTipContainer>
      <Tip />
    </PilotTipContainer>
  );
}
